import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { IMAGES } from '../data/content';
const bullets = ['Descarga inmediata', 'Pago único', 'Acceso de por vida', 'Garantía de 7 días'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream px-4 pb-12 pt-8 sm:pt-12" data-id="element-124" data-mp="4mi4le603ug2">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-64 bg-gold/10 blur-3xl" aria-hidden="true" data-id="element-125" data-mp="129qurmgy5roe" />
      <div className="relative mx-auto flex w-full max-w-3xl flex-col items-center text-center" data-id="element-126" data-mp="xaxfboi3nqll">
        <p className="font-display text-sm font-bold uppercase tracking-[0.42em] text-navy" data-id="element-127" data-mp="s9q8brns6vfz">
          Dra. Karito
        </p>
        <span className="mt-3 h-px w-16 bg-gold" aria-hidden="true" data-id="element-128" data-mp="nekm0rqgverd" />
        <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-129" data-mp="3d33ecx6girk8">
          Ruta Clínica de Menopausia™
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-5 font-display text-[2rem] font-bold leading-[1.1] text-navy sm:text-5xl md:text-[3.4rem]" data-id="element-130" data-mp="3j8sdfvbir9n7">
          Nunca vuelvas a dudar qué hacer con una paciente en{' '}
          <em className="italic text-gold" data-id="element-131" data-mp="3e8ehvcr3ts62">menopausia</em>
        </motion.h1>

        <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-132" data-mp="30hhohjpct6xy">
          Evalúa, prescribe, ajusta y monitoriza con una{' '}
          <strong className="font-semibold text-navy" data-id="element-133" data-mp="35aud3tu19dqp">Ruta Clínica que te guía paso a paso</strong>{' '}
          en menos de 5 minutos. La evidencia más reciente convertida en un sistema práctico de
          decisiones clínicas.
        </p>

        <p className="mt-3 max-w-xl text-sm text-navy/55 sm:text-base" data-id="element-134" data-mp="2hinbaf5jgejw">
          Más de 2.000 médicos ya utilizan este sistema para tomar decisiones más rápidas, seguras y
          respaldadas por evidencia.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} src={IMAGES.mockup} alt="Los 6 tomos de la Ruta Clínica de Menopausia en formato físico y digital" className="mt-7 w-full max-w-lg" data-id="element-135" data-mp="s332p6wnmcud" />

        <div className="mt-6 w-full" data-id="element-136" data-mp="db2fjhflgjob">
          <CTAButton id="hero-cta" label="Quiero la Ruta Clínica completa" data-id="element-137" data-mp="1b1fcmuve3qr0" />
        </div>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-138" data-mp="161ay3ae1l63f">
          {bullets.map(b => <li key={b} className="flex items-center gap-1.5 text-xs font-medium text-navy/70 sm:text-sm" data-id="element-139" data-mp="111omt6hrxzx9">
              <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-140" data-mp="x3h0zx8ge8f7" />
              {b}
            </li>)}
        </ul>
      </div>
    </header>;
}